import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError} from 'rxjs';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class DeclinioPropostaService {
  constructor(private httpClient: HttpClient, private appConfigurationService: AppConfigurationService) {}

  decliniarProposta(proposalId: string, declineReason: string): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/DeclineReason?proposalId=${proposalId}&declineReason=${declineReason}`,
        {},
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
